module.exports = __webpack_public_path__ + "media/images/static/graduate_jobs/image-default-a5c6766879e8c29e768c8382562ce549.png";